// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { RESOURCES, LANGUAGE_CODES, directionFor } from './locales';
import workspace from './locales/workspace';
const workspaceResources = Object.fromEntries(Object.entries(RESOURCES).map(([code, resource]) => [code, { ...resource, workspace: workspace[code] || workspace.en }]));

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: workspaceResources,
    ns: ['translation', 'workspace'],
    defaultNS: 'translation',
    // English is the source of truth for every generated locale, so fall back
    // to it rather than French: a missing key should not switch the user's UI
    // to a third language.
    fallbackLng: 'en',
    supportedLngs: LANGUAGE_CODES,
    nonExplicitSupportedLngs: true,   // 'es-MX' resolves to 'es'
    detection: {
      // /fr/…, /es/… (public pages in a given language) win from the first render; for any other
      // path the first segment is not a language and detection falls through to the saved choice.
      order: ['path', 'localStorage', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],       // the choice survives a reload
    },
    interpolation: {
      escapeValue: false,
    },
  });

// Keep <html lang/dir> in step with the chosen language. `dir` is what makes an
// RTL locale usable; setting it here means adding one later is a data change in
// locales/index.js rather than a code change.
const applyDocumentLanguage = (code) => {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = code;
  document.documentElement.dir = directionFor(code.split('-')[0]);
};

applyDocumentLanguage(i18n.resolvedLanguage || 'en');
i18n.on('languageChanged', applyDocumentLanguage);

export default i18n;
